import React, { Component } from 'react'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import DerivationsForm from './Derivation.Form'

class DerivationCreate extends Component {
  render() {
    return (
      <div className="crud-wrapper">
        <DashboardHeader title={<Trans>Nueva Derivación</Trans>}>
          <Link to={`/derivations`} className="btn btn-primary">
            <Trans>Volver</Trans>
          </Link>
        </DashboardHeader>
        <div className="main-content">
          <DerivationsForm initialState={{}} />
        </div>
      </div>
    )
  }
}

export default withTranslation()(DerivationCreate)
